import React from 'react';

export const WandsIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="19.5" height="19.5" viewBox="0 0 19.5 19.5" fill="none" {...props}>
    <g>
      <path d="M5.238,17.03l5.321-6.56M3.02,14.194l6.73-8.194M18.75,9.75c0,4.971-4.029,9-9,9S.75,14.721.75,9.75,4.779.75,9.75.75s9,4.029,9,9Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"/>
    </g>
  </svg>
);

export const CupsIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="19.5" height="19.5" viewBox="0 0 19.5 19.5" fill="none" {...props}>
    <path d="M18.75,9.75c0,4.971-4.029,9-9,9S.75,14.721.75,9.75,4.779.75,9.75.75s9,4.029,9,9ZM14.687,9.01c0,2.727-2.211,4.937-4.937,4.937s-4.937-2.211-4.937-4.937,9.875-2.727,9.875,0ZM14.687,8.772c0,2.727-9.875,2.727-9.875,0" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"/>
  </svg>
);

export const SwordsIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="19.5" height="19.5" viewBox="0 0 19.5 19.5" fill="none" {...props}>
    <path d="M7.509,15.453h4.447M9.754,17.983l.016-12.843M18.75,9.75c0,4.971-4.029,9-9,9S.75,14.721.75,9.75,4.779.75,9.75.75s9,4.029,9,9ZM10.084,4.116" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"/>
  </svg>
);

export const PentaclesIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="19.5" height="19.5" viewBox="0 0 19.5 19.5" fill="none" {...props}>
    <path d="M18.75,9.75c0,4.971-4.029,9-9,9S.75,14.721.75,9.75,4.779.75,9.75.75s9,4.029,9,9ZM8.486,8.011h-4.089s3.308,2.404,3.308,2.404l-1.264,3.889,3.308-2.404,3.308,2.404-1.264-3.889,3.308-2.404h-4.089s-1.264-3.889-1.264-3.889l-1.264,3.889Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"/>
  </svg>
);

export const MajorArcanaIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="19.5" height="19.5" viewBox="0 0 19.5 19.5" fill="none" {...props}>
    <path d="M18.75,9.75c0,4.971-4.029,9-9,9S.75,14.721.75,9.75,4.779.75,9.75.75s9,4.029,9,9ZM1.54,6.063c1.436-.97,3.168-1.537,5.032-1.537,4.971,0,9,4.029,9,9,0,1.243-.252,2.426-.707,3.503" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"/>
  </svg>
);

export const MapIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6" {...props}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 6.75V15m6-6v8.25m.503 3.498 4.875-2.437c.381-.19.622-.58.622-1.006V4.82c0-.836-.88-1.38-1.628-1.006l-3.869 1.934c-.317.159-.69.159-1.006 0L9.503 3.252a1.125 1.125 0 0 0-1.006 0L3.622 5.689C3.24 5.88 3 6.27 3 6.695V19.18c0 .836.88 1.38 1.628 1.006l3.869-1.934c.317-.159.69-.159 1.006 0l4.994 2.497c.317.158.69.158 1.006 0Z" />
  </svg>
); 